module.exports = __webpack_public_path__ + "img/sonosradio.df07a1e4.png";